export default "__VITE_ASSET__BORk$rQY__"